import Annotation from '@zxy-cloud/react-image-annotation';
import { JSONPath } from 'jsonpath-plus';
import React from 'react';
import { fetchGet } from '../../store/fetch';

interface IAnnotationGeometry {
    height: number;
    width: number;
    x: number;
    y: number;
    type: string;
}

interface IAnnotation {
    data: {
        id: string;
        title: string;
    };
    geometry: IAnnotationGeometry;
}

export function SurveyInspectionStandardDataAnnotation(props: {
    surveyId: string;
    assetIdPath: string;
    annotationsPath: string;
    smallFont?: boolean;
}) {
    const [state, setState] = React.useState<{ assetId: string; annotations: IAnnotation[] } | undefined>();

    React.useEffect(() => {
        const fetchData = async () => {
            const response = await fetchGet(`/api/surveys/${props.surveyId}/inspectionStandardData`);

            const inspectionStandardData = response.json;
            const assetId = JSONPath({ path: props.assetIdPath, json: inspectionStandardData, wrap: false });
            let annotations = JSONPath({ path: props.annotationsPath, json: inspectionStandardData, wrap: false }) ?? [];
            annotations = Array.isArray(annotations) ? annotations : [annotations];

            setState({ assetId, annotations });
        };
        void fetchData();
    }, [props.annotationsPath, props.assetIdPath, props.surveyId]);

    function renderContent({ annotation }: { annotation: IAnnotation }) {
        return <div key={annotation.data.id} />;
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    function renderHighlight({ annotation, active }: { annotation: IAnnotation; active: boolean }) {
        const { geometry, data } = annotation;
        if (!geometry) {
            return null;
        }
        let fontSize = '13px';
        if (props.smallFont) {
            fontSize = '10px';
        }

        const borderColor = '#f500e4';
        return (
            <div
                key={data.id}
                style={{
                    fontSize,
                    border: `dashed 3px ${borderColor}`,
                    background: active ? 'rgba(200, 200, 200, 0.5)' : undefined,
                    position: 'absolute',
                    left: `${geometry.x}%`,
                    top: `${geometry.y}%`,
                    height: `${geometry.height}%`,
                    width: `${geometry.width}%`,
                }}
            >
                {data.title && data.title !== '' && (
                    <span
                        style={{
                            color: borderColor,
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                            padding: '2px',
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        }}
                    >
                        {data.title}
                    </span>
                )}
            </div>
        );
    }

    if (!state || !state.assetId) {
        return null;
    }

    return (
        <Annotation
            src={`/api/assets/${state.assetId}/download`}
            alt="Image with annotations"
            style={{ imageOrientation: 'from-image' }}
            annotations={state.annotations}
            disableAnnotation={true}
            renderContent={(annotationProps: any) => renderContent(annotationProps)}
            renderHighlight={(annotationProps: any) => renderHighlight(annotationProps)}
            renderOverlay={() => <div />}
        />
    );
}
